import elementService from "@/common/ElementService";

export default new class ProductCustomerLiveNotificationService {
    private isVisibleBrowsingBox = true;

    public init(): void {
        const browsingViewsText = document.querySelector<HTMLDivElement>("#js-browsing-views-text");
        const activeWatchdogText = document.querySelector<HTMLDivElement>("#js-active-watchdogs-text");

        if (browsingViewsText === null || activeWatchdogText === null) {
            return;
        }

        const liveInfoBox = elementService.querySelector<HTMLDivElement>("#js-live-info-box");

        const hideActiveWatchdogsBox = (): void => {
            activeWatchdogText.classList.add("hidden");
        };

        const showActiveWatchdogsBox = (): void => {
            liveInfoBox.classList.remove("live-info-box-green");
            liveInfoBox.classList.add("live-info-box-blue");
            activeWatchdogText.classList.remove("hidden");
        };

        const hideBrowsingViewsBox = (): void => {
            browsingViewsText.classList.add("hidden");
            this.isVisibleBrowsingBox = false;
        };

        const showBrowsingBox = (): void => {
            liveInfoBox.classList.remove("live-info-box-blue");
            liveInfoBox.classList.add("live-info-box-green");
            browsingViewsText.classList.remove("hidden");
            this.isVisibleBrowsingBox = true;
        };

        hideActiveWatchdogsBox();

        setTimeout(() => {
            hideBrowsingViewsBox();
            showActiveWatchdogsBox();

            setInterval(() => {
                if (this.isVisibleBrowsingBox) {
                    hideBrowsingViewsBox();
                    showActiveWatchdogsBox();
                } else {
                    hideActiveWatchdogsBox();
                    showBrowsingBox();
                }
            }, 28_000);
        }, 10_000);
    }
}();
